
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  props: {
    task: {
      type: Object,
      required: true,
    },
  },
  emits: ["updated"],
  computed: {},
  watch: {
    task: {
      handler() {
        this.updatedTask = JSON.parse(JSON.stringify(this.task));
      },
      immediate: true,
    },
  },
  data() {
    return {
      updatedTask: {} as any,
    };
  },
  methods: {
    submit: function () {
      this.$emit("updated", this.updatedTask);

      const el = this.$refs["closeBtn"] as any;
      el.click();
    },
  },
});
